module.exports = __webpack_public_path__ + "static/media/logout.ff1d2092.svg";